export default __webpack_public_path__ + "static/media/logo.5b2fef15.svg";